class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m2.499 1.794-.707.707L3.5 4.208l.707-.707-1.708-1.707Zm9.999 9.995-.707.707 1.707 1.708.707-.707-1.707-1.708ZM6.5 1h-1v2h1V1ZM3 5.5H1v1h2v-1Zm12 4h-2v1h2v-1ZM10.5 13h-1v2h1v-2Zm-2.21-2.465-1.855 1.86a2.002 2.002 0 0 1-2.83-2.83l1.86-1.86L4.755 7 2.9 8.86a3 3 0 0 0-.03 4.27A3 3 0 0 0 5 14a3.035 3.035 0 0 0 2.16-.9L9 11.245l-.71-.71Zm-.585-5.07 1.86-1.86a2.001 2.001 0 0 1 2.83 2.83l-1.86 1.86.71.705L13.1 7.14a3 3 0 0 0 .03-4.27A3 3 0 0 0 11 2a3.035 3.035 0 0 0-2.16.9L7 4.755l.705.71Z"></path></svg>';
  }
}
const t = "pi-unlink";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
